import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthRepository, PermissionAction} from './auth.repository';

/**
 * Route guard: `data: {module: 'Projects'}` (on the route or an ancestor, e.g. the feature's root route)
 * needs view on the module; add pages also set `action: 'create'` and edit pages `action: 'edit'`, which
 * need write. Without the permission the user goes to their landing page.
 */
export const permissionGuard: CanActivateFn = (route) => {
    const auth = inject(AuthRepository);
    const router = inject(Router);

    const moduleName = route.pathFromRoot
        .map((r) => r.data?.['module'] as string | undefined)
        .filter(Boolean)
        .at(-1);
    if (!moduleName) return true;

    const action = (route.data?.['action'] as PermissionAction | undefined) ?? 'view';
    if (auth.can(moduleName, 'view') && auth.can(moduleName, action)) return true;

    return router.parseUrl(auth.getLandingRouteByPermission());
};
